<template>
  <div class="corpo-pagina">

    <!-- TITOLO -->
    <div class="row row-text">
      <div class="col s12">
        <h4>{{ t('title.customize.page') }}</h4>
        <p>{{ t('customize.description.header') }}</p>
      </div>
    </div>

    <div class="divider"></div>

    <div class="row">

      <!-- DESTRA: UPLOAD -->
      <div class="col s12 m7 l8">

        <h5 class="section-title">{{ t('indication.upload.image.4') }}</h5>

        <p class="upload-description">
          {{ t('indication.upload.image.3') }}<br />
          {{ t('indication.upload.image.1') }}<br />
        </p>

        <!-- FILE UPLOAD MODERNO -->
        <div class="upload-area" @dragover.prevent="dragOver = true" @dragleave.prevent="dragOver = false"
          @drop.prevent="handleDrop">

          <!-- BUTTON -->
          <button type="button" class="btn red" @click="triggerFileDialog">
            <i class="material-icons left">upload</i>
            {{ t('choose.file.filed') }}
          </button>

          <!-- HIDDEN FILE INPUT -->
          <input type="file" ref="fileInput" class="hidden-file" @change="onFileSelected" accept=".jpg,.jpeg,.png" />

          <!-- CLICKABLE TEXT INPUT -->
          <input type="text" class="file-path-display" :value="selectedFileName" readonly @click="triggerFileDialog" />

          <!-- DRAG OVER OVERLAY -->
          <div v-if="dragOver" class="drop-overlay">
            {{ t('indication.upload.image.3') }}
          </div>
        </div>

        <!-- ERROR -->
        <p v-if="errorMessage" class="error-message" v-html="errorMessage"></p>

      </div>

      <!-- SINISTRA: PREVIEW -->
      <div class="col s12 m5 l4">

        <!-- IMMAGINE -->
        <img v-if="previewUrl && previewUrl !== 'non-image-file'" :src="previewUrl" class="preview-img-upgraded" />

        <!-- PLACEHOLDER -->
        <div v-else class="preview-placeholder-upgraded">
          <div class="placeholder-text">
            <strong>{{ t('no.image.selected') }}</strong><br>
            {{ t('indication.upload.image.1') }}<br>
            {{ t('indication.upload.image.2') }}
          </div>
        </div>

      </div>
    </div>

    <div class="row">

      <!-- BOTTONI -->
      <div class="col s12 m12 l12">

        <a v-if="this.isNew || this.isBack" v-red-tooltip="t('btn.back')" id="goback" href="javascript:void(0)"
          class="btn-large btn-back" @click="goBack()">
          <i class="material-icons left arrow-back">keyboard_arrow_left</i>
        </a>

        <a id="savestructure" class="btn-large teal" href="javascript:void(0)" @click="sendForm"
          :disabled="errorMessage">
          <i class="material-icons left">save</i>
          {{ t('bt.create.event.save.next') }}
        </a>

        <a v-if="!this.isNew" id="bypassstructure" class="btn-large ml-2" href="javascript:void(0)" @click="sendFormLascia">
           {{ t('btn.lascia.immagine.default') }}<i class="material-icons right ml-2">keyboard_arrow_right</i>
        </a>

      </div>
      <div class="col s12 m5 l8"></div>

    </div>

  </div>

</template>

<script>
import translationStore from '@/store/translations'
import eventSetting from '@/store/eventSettings.js'
import apiService from '@/services/apiService.js'
import loadingStore from '@/store/loading.js'
import toast from '@/services/toast.js'

export default {
  props: {
    isNew: {
      type: Boolean,
      default: false
    },
    isBack: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      previewUrl:
        process.env.VUE_APP_URL_AWS_CUSTOM +
        '/' +
        eventSetting.getters.eventModel.logo,

      selectedFile: null,
      errorMessage: null,
      selectedFileName: '',
      dragOver: false,

      translation: translationStore,
      eventSetting,
      toast,

      MAX_FILE_SIZE_MB: process.env.VUE_APP_DIM_IMG,
      REQUIRED_WIDTH: process.env.VUE_APP_WITDH_IMG,
      REQUIRED_HEIGHT: process.env.VUE_APP_HEIGHT_IMG
    }
  },

  methods: {
    handleDrop (e) {
      this.dragOver = false
      const file = e.dataTransfer.files[0]
      if (file) {
      // Simula il change dell’input
        const dt = new DataTransfer()
        dt.items.add(file)
        this.$refs.fileInput.files = dt.files
        this.onFileSelected({ target: this.$refs.fileInput })
      }
    },
    triggerFileDialog () {
      this.$refs.fileInput.click()
    },
    t (key) {
      return translationStore.getters.traduzione(key)
    },

    goBack () {
      this.$router.push('/new-event-step2-back')
    },
    sendFormLascia () {
      this.$router.push('/import-guests')
    },

    onFileSelected (event) {
      loadingStore.commit('setLoading', true)
      this.errorMessage = null
      this.selectedFile = null
      this.previewUrl = null

      const file = event.target.files[0]
      if (!file) return

      // Tipo file
      const allowedTypes = ['image/jpeg', 'image/png']
      if (!allowedTypes.includes(file.type)) {
        this.errorMessage = this.t('error.type.not.allowed')
        this.resetFileInput()
        loadingStore.commit('setLoading', false)
        return
      }

      // Dimensione file
      const maxSize = this.MAX_FILE_SIZE_MB * 1024 * 1024
      if (file.size > maxSize) {
        this.errorMessage = this.t('img.size.large.error')
        this.resetFileInput()
        loadingStore.commit('setLoading', false)
        return
      }

      // Dimensioni immagine
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = new Image()
        img.onload = () => {
          if (
            img.width !== parseInt(this.REQUIRED_WIDTH) ||
            img.height !== parseInt(this.REQUIRED_HEIGHT)
          ) {
            this.errorMessage = this.t('img.width.height.error')
            this.resetFileInput()
          } else {
            this.selectedFile = file
            this.previewUrl = URL.createObjectURL(file)
          }
          loadingStore.commit('setLoading', false)
        }

        img.onerror = () => {
          this.errorMessage = this.t('img.read.error')
          this.resetFileInput()
          loadingStore.commit('setLoading', false)
        }

        img.src = e.target.result
      }
      reader.readAsDataURL(file)
    },

    resetFileInput () {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    },

    async sendForm () {
      loadingStore.commit('setLoading', true)

      if (this.errorMessage) return

      const formData = new FormData()
      formData.append('imageheader', this.selectedFile)
      formData.append('event_id', this.eventSetting.getters.uidEvent)

      let url = process.env.VUE_APP_URL_EVENTS + '/events/customize'
      if (!this.isNew) url += '/edit'

      try {
        const token = await apiService.getClientCredentialsToken()
        const responseData = await apiService.sendRequestWithBearer(
          'POST',
          url,
          token,
          formData
        )

        if (responseData && responseData.message === 'ok') {
          const msg = this.t('pagina.event.inserimeto.headerevento.ok')
          this.toast.createStampToast('thumb_up', msg, 'toast-green')

          if (this.isNew) {
            this.$router.push('/import-guests')
          } else {
            eventSetting.dispatch('reloadNewImage', responseData.s3)
            this.previewUrl =
              process.env.VUE_APP_URL_AWS_CUSTOM +
              '/' +
              eventSetting.getters.eventModel.logo
          }
        } else {
          this.$router.push('/error')
        }
      } catch (e) {
        this.$router.push('/error')
      } finally {
        loadingStore.commit('setLoading', false)
      }
    }
  },

  mounted () {
    if (!this.eventSetting.getters.eventModel.logo) {
      this.previewUrl = null
    }
    loadingStore.commit('setLoading', false)
  }
}
</script>

<style scope>
/* LAYOUT */
.upgraded-layout {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
}

/* IMMAGINE */
.preview-img-upgraded {
  width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: cover;
}

/* PLACEHOLDER */
.preview-placeholder-upgraded {
  width: 100%;
  height: 300px;
  border-radius: 12px;
  border: 2px dashed #c42634;
  background: #fbe9e9;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #b12222;
}

/* TESTI */
.section-title {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 20px;
}

.upload-description {
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.5;
}

/* BOTTONI */
.actions-upgraded {
  margin-top: 35px;
  display: flex;
  gap: 15px;
}

/* FILE INPUT FIX */
.hidden-file-input-upgraded {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.file-path {
  background: #fff;
  border-radius: 6px;
  padding-left: 10px;
}

/* ERRORI */
.error-message {
  color: #c42634;
  font-weight: bold;
}

.file-field input[type=file] {
  opacity: 0;
}

.custom-file-field {
  display: flex;
  align-items: center;
  gap: 12px;
}

.hidden-file {
  display: none !important;
}

.upload-area {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
}

.hidden-file {
  display: none !important;
}

.file-path-display {
  border: none;
  border-bottom: 1px solid #9e9e9e;
  outline: none;
  padding: 6px 4px;
  width: 100%;
  font-size: 1rem;
  color: #333;
  cursor: pointer;
}

.file-path-display:hover {
  border-bottom-color: #e53935;
}

.drop-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255,0,0,0.15);
  border: 2px dashed #e53935;
  color: #c42634;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  pointer-events: none;
}

.error-message {
  color: #c42634;
  margin-top: 8px;
  font-weight: bold;
}

</style>
